module.exports = __webpack_public_path__ + "static/img/s-logo-15.c3ddba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/s-logo-15.png
// module id = 410
// module chunks = 2